<button #triggerButton class="options-button" [matMenuTriggerFor]="optionsMenu">
  <ng-container *ngIf="buttonCvxIcon; else defaultIcon">
    <mat-icon
      [svgIcon]="buttonCvxIcon"
      [ngClass]="{
        'purple-text': hasUnresolvedFlags
      }"
    ></mat-icon>
  </ng-container>

  <ng-template #defaultIcon>
    <mat-icon>{{ buttonIcon }}</mat-icon>
  </ng-template>
</button>
<mat-menu #optionsMenu>
  <ng-container *ngFor="let option of options">
    <button
      mat-menu-item
      *ngIf="!option.hidden"
      (click)="onOptionSelect(option)"
    >
      <span class="options-menu">{{ option.text }}</span>
    </button>
  </ng-container>
</mat-menu>
